// Function to fetch JSON data asynchronously
// function fetchDataSync() {
//
//   var session_id = 'variant_surcharge_id_3';
//   var url = 'https://poppin-candy.com/collections/All?view=product-data';
//
//   try {
//     // Check if data is already in sessionStorage
//     const cachedData = sessionStorage.getItem(session_id);
//     if (cachedData) {
//       console.log("Returning data from cache.");
//       return JSON.parse(cachedData); // Parse and return cached JSON
//     }
//
//     // Make a synchronous XHR request
//     const xhr = new XMLHttpRequest();
//     xhr.open("GET", url, false); // false makes the request synchronous
//     xhr.send();
//
//     if (xhr.status === 200) {
//       const data = JSON.parse(xhr.responseText); // Parse the JSON response
//       sessionStorage.setItem(session_id, JSON.stringify(data)); // Cache the data
//       console.log("Fetched and cached data.");
//       return data;
//     } else {
//       throw new Error(`HTTP error! Status: ${xhr.status}`);
//     }
//   } catch (error) {
//     console.error("Failed to fetch data:", error);
//     return null; // Return null on failure
//   }
// }
//
// document.addEventListener("DOMContentLoaded", function() {
//   fetchDataSync();
// });


const minWeight = 62.5;
const Price125 = 2.99;
const Price250 = 4.99;
const Price500 = 8.99;
const Price1kg = 14.99;
const Platter = 4.99;
 
document.querySelectorAll(".pm-selection-button").forEach((button) => {
  button.addEventListener("click", function () {
    const selectedCollection = button.getAttribute("data-button-collection");
    if (selectedCollection.includes('Gluten')) {
      document.querySelector(".pm-allergies__inner").style.display = 'block';
    }
    else if (selectedCollection.includes("Halal")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    } 
    else if (selectedCollection.includes("Vegan")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    } 
    else if (selectedCollection.includes("vegetarian")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    }
    else if (selectedCollection.includes("Gluten-Free")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    }
    else if (selectedCollection.includes("Dairy-Free")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    }
    else if (selectedCollection.includes("Sugar-Free-1")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    }
    else if (selectedCollection.includes("NAFNAC")) {
      document.querySelector(".pm-allergies__inner").style.display = "block";
    }
    else {
      document.querySelector(".pm-allergies__inner").style.display = "none";
    }
    document.querySelectorAll(".pm-selection-button").forEach((btn) => {
      btn.classList.remove("selection");
    });
    button.classList.add("selection");
    const productSelectionSection = document.querySelector(
      ".pm-product-selection"
    );

    document.querySelector(".pm-product-selection").style.display = "flex";
    productSelectionSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    const formattedCollection = selectedCollection.replace(/\s+/g, "-");
    localStorage.setItem("selectedCollection", formattedCollection);
  });
});

document.querySelectorAll(".pm-amount-selection").forEach((button) => {
  button.addEventListener("click", function () {
    const bagAmount = button.getAttribute("data-variant-amount");

    document.querySelectorAll(".pm-amount-selection").forEach((btn) => {
      btn.classList.remove("selection");
    });
    button.classList.add("selection");
    const weightSelectionSection = document.querySelector(
      ".pm-weight-selection"
    );
    document.querySelector(".pm-weight-selection").style.display = "block";
    weightSelectionSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    const amountNumber = parseInt(bagAmount.match(/\d+/));
    const button125gs = document.querySelectorAll('[data-variant-weight="125g"]');
    const button250gs = document.querySelectorAll('[data-variant-weight="250g"]');
    const button500gs = document.querySelectorAll('[data-variant-weight="500g"]');
    const button1000gs = document.querySelectorAll('[data-variant-weight="1kg"]');
    const button2000gs = document.querySelectorAll('[data-variant-weight="2kg"]');

    if (amountNumber === 1) {
      for(const button125g of button125gs) {
        if(button125g.dataset.first.indexOf(bagAmount) > -1) {
          button125g.classList.remove("disabled");
        } else {
          button125g.classList.add("disabled");
        }
      }
      for(const button250g of button250gs) {
        console.log(button250g);
        if(button250g.dataset.first.indexOf(bagAmount) > -1) {
          console.log(button250g);
          button250g.classList.remove("disabled");
        } else {
          button250g.classList.add("disabled");
        }
      }
      for(const button500g of button500gs) {
        console.log(button500g);
        if(button500g.dataset.first.indexOf(bagAmount) > -1) {
          console.log(button500g);
          button500g.classList.remove("disabled");
        } else {
          button500g.classList.add("disabled");
        }
      }
      for(const button1000g of button1000gs) {
        console.log(button1000g);
        if(button1000g.dataset.first.indexOf(bagAmount) > -1) {
          console.log(button1000g);
          button1000g.classList.remove("disabled");
        } else {
          button1000g.classList.add("disabled");
        }
      }
      for(const button2000g of button2000gs) {
        button2000g.classList.add("disabled");
      }
    } else if (amountNumber === 2) {
      for(const button125g of button125gs) {
        button125g.classList.add("disabled");
      }
      for(const button250g of button250gs) {
        button250g.classList.add("disabled");
      }
      for(const button500g of button500gs) {
        if(button500g.dataset.first.indexOf(bagAmount) > -1) {
          button500g.classList.remove("disabled");
        } else {
          button500g.classList.add("disabled");
        }
      }
      for(const button1000g of button1000gs) {
        if(button1000g.dataset.first.indexOf(bagAmount) > -1) {
          button1000g.classList.remove("disabled");
        } else {
          button1000g.classList.add("disabled");
        }
      }
      for(const button2000g of button2000gs) {
        button2000g.classList.add("disabled");
      }
    } else if (amountNumber === 4) {
      for(const button125g of button125gs) {
        button125g.classList.add("disabled");
      }
      for(const button250g of button250gs) {
        button250g.classList.add("disabled");
      }
      for(const button500g of button500gs) {
        if(button500g.dataset.first.indexOf(bagAmount) > -1) {
          button500g.classList.remove("disabled");
        } else {
          button500g.classList.add("disabled");
        }
      }
      for(const button1000g of button1000gs) {
        if(button1000g.dataset.first.indexOf(bagAmount) > -1) {
          button1000g.classList.remove("disabled");
        } else {
          button1000g.classList.add("disabled");
        }
      }
      for(const button2000g of button2000gs) {
        button2000g.classList.add("disabled");
      }
    } else if (amountNumber === 8) {
      for(const button125g of button125gs) {
        button125g.classList.add("disabled");
      }
      for(const button250g of button250gs) {
        button250g.classList.add("disabled");
      }
      for(const button500g of button500gs) {
        if(button500g.dataset.first.indexOf(bagAmount) > -1) {
          console.log(button500g);
          button500g.classList.remove("disabled");
        } else {
          button500g.classList.add("disabled");
        }
      }
      for(const button1000g of button1000gs) {
        if(button1000g.dataset.first.indexOf(bagAmount) > -1) {
          button1000g.classList.remove("disabled");
        } else {
          button1000g.classList.add("disabled");
        }
      }
      for(const button2000g of button2000gs) {
        if(button2000g.dataset.first.indexOf(bagAmount) > -1) {
          button2000g.classList.remove("disabled");
        } else {
          button2000g.classList.add("disabled");
        }
      }
    }
    showButtonAndAttachListener();
  });
});

document.querySelectorAll(".pm-weight-selection-btn").forEach((button) => {
  button.addEventListener("click", function () {
    document.querySelectorAll(".pm-weight-selection-btn").forEach((btn) => {
      btn.classList.remove("selection");
    });

    button.classList.add("selection");
    const nextScreenContainer = document.querySelector(
      ".next-screen__container"
    );
    nextScreenContainer.style.opacity = "1";
    console.log("Scrolling to:", nextScreenContainer);
    nextScreenContainer.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  });
});



let selectedProductId = null;
let selectedSweetAmount = null;
let selectedWeight = null;
let matchingVariantId = null;
const mainProductId = localStorage.getItem("parentProductId");

document.querySelectorAll(".pm-style-selection__button").forEach((button) => {
  button.addEventListener("click", function () {
    const buttonBag = button.getAttribute("data-button-name");
    selectedProductId = button.getAttribute("data-button-product");
    const productImg = button.getAttribute("data-product-image");
    localStorage.setItem("productImage", productImg);
    console.log("Product selected:", selectedProductId);
    if (productHasVariants(selectedProductId)) {
      console.log(
        "Product has variants. Please select sweet amount and weight."
      );
      selectedSweetAmount = null;
      selectedWeight = null;
    } else {
       selectedSweetAmount = this.getAttribute("data-variant-amount");
       nonVariantPrice = parseFloat(this.getAttribute("data-product-pricing"));
      console.log("Product has no variants. Adding to cart directly.");
      localStorage.setItem("parentProductId", selectedProductId);
      localStorage.setItem("selectedSweetAmount", selectedSweetAmount);
      localStorage.setItem("selectedPrice", nonVariantPrice)
    }
    document.querySelectorAll(".pm-style-selection__button").forEach((btn) => {
      btn.classList.remove("selection");
    });
    button.classList.add("selection");
    localStorage.setItem("productButtonName", buttonBag);
    if (buttonBag === "Bag") {
      document.querySelector(".pm-sweet-selection").style.display = "block";
      if (window.innerWidth <= 768) {
        document.querySelector(".pm-sweet-selection").scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      document.querySelector(".toggle-arrow").style.display = "block";
      document.querySelector(".non-variant__next").style.opacity = "0";
    } else {
      document.querySelector(".non-variant__next").scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      document.querySelector(".pm-sweet-selection").style.display = "none";
      document.querySelector(".toggle-arrow").style.display = "none";
      document.querySelector(".pm-weight-selection").style.display = "none";
      document.querySelector(".non-variant__next").style.opacity = "1";
      attachNonVariantBtnListener();
    }
  });
});

const sweetAmountButtons = document.querySelectorAll("[data-variant-amount]");

sweetAmountButtons.forEach((button) => {
  button.addEventListener("click", function () {
    selectedSweetAmount = this.getAttribute("data-variant-amount");
    console.log("Sweet Amount selected:", selectedSweetAmount);
    findMatchingVariant();
  });
});

document.querySelectorAll(".pm-weight-selection-btn").forEach((button) => {
  button.addEventListener("click", function () {
    selectedWeight = this.getAttribute("data-variant-weight");
    localStorage.setItem("selectedBagSize", selectedWeight);
    findMatchingVariant();
  });
});

function productHasVariants(productId) {
  const product = window.productsData[productId];
  if (!product) {
    return false;
  }
  console.log(
    "Variants length:",
    product.variants ? product.variants.length : 0
  );
  return product.variants && product.variants.length > 1;
}

function findMatchingVariant() {
  if (!selectedProductId) {
    console.log("Please select a product first.");
    return;
  }

  if (!selectedSweetAmount || !selectedWeight) {
    console.log("Both sweet amount and weight must be selected.");
    return;
  }

  const product = window.productsData[selectedProductId];
  if (!product) {
    console.log("Product not found for selectedProductId:", selectedProductId);
    return;
  }

  let selectedWeightFormatted = `${selectedWeight}`;
  if (selectedWeight === "1kg") {
    selectedWeightFormatted = "1kg";
  }

  console.log(
    `Selected weight: ${selectedWeightFormatted}, selected sweet amount: ${selectedSweetAmount}`
  );

  const matchingVariant = product.variants.find((variant) => {
    const weightRegex = /\d+(g|kg)/;
    const match = variant.title.match(weightRegex);

    if (match) {
      const variantWeight = match[0];
      const variantTitleLower = variant.title.toLowerCase();

      console.log(
        `Checking variant: ${variant.title} - extracted weight: ${variantWeight}`
      );
      const isWeightMatch = variantWeight === selectedWeightFormatted;
      const isSweetAmountMatch = variantTitleLower.includes(
        selectedSweetAmount.toLowerCase()
      );

      return isWeightMatch && isSweetAmountMatch;
    }

    return false;
  });

  if (matchingVariant) {
    console.log("Matching variant found:", matchingVariant);
    matchingVariantId = matchingVariant.id;
    localStorage.setItem("selectedSweetAmount", selectedSweetAmount);
    localStorage.setItem("parentProductId", matchingVariantId);
    localStorage.setItem("selectedBagSize", selectedWeightFormatted);

    if (!matchingVariantId) {
      console.error("No product ID found in localStorage");
      return;
    }

    const fetchUrl = `/variants/${matchingVariantId}.js`;
    console.log("Fetching variant details from:", fetchUrl);
    fetch(fetchUrl)
      .then((response) => {
        console.log("Fetch response status:", response.status);
        if (!response.ok) {
          console.error(
            `Server returned ${response.status}: ${response.statusText}`
          );
          return Promise.reject(
            `Failed to fetch product details. Status: ${response.status}`
          );
        }
        return response.json();
      })
      .then((data) => {
        console.log("Fetch successful, data received:", data);
        if (data && data.price) {
          const price = data.price / 100;
          localStorage.setItem("selectedPrice", price);
          console.log("Price retrieved and stored in localStorage:", price);
        } else {
          console.error("No price found in the response data.");
        }
      })
      .catch((error) => {
        console.error("Error during fetch:", error);
      });
  } else {
    console.log("No matching variant found.");
    matchingVariantId = null;
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const localStorageKey = "selectedPrice";
  const redirectPrevUrl = "https://poppin-candy.com/pages/pick-n-mix";

  // Check if we're on a pick & mix collection page
  if (window.location.pathname.startsWith("/collections/")) {
    // Only run if selectedPrice is not in localStorage
    if (localStorage.getItem(localStorageKey) === null) {
      window.location.href = redirectPrevUrl;
    }
  }
});

function showButtonAndAttachListener() {
  const variantBtn = document.getElementById("variantBtn");
  if (variantBtn) {
    console.log("Attaching event listener to VariantBtn");

    variantBtn.addEventListener("click", function () {
      console.log("Variant button clicked!");

      findMatchingVariant();
      if (matchingVariantId) {
        redirectToCollectionPage();
      } else {
        alert("No matching variant found. Please check your selections.");
      }
    });
  }
}
function attachNonVariantBtnListener() {
  const nonVariantBtn = document.getElementById("NonVariantBtn");
  if (nonVariantBtn) {
    console.log("Attaching event listener to NonVariantBtn");
    nonVariantBtn.addEventListener("click", function () {
      console.log("Non-Variant button clicked!");
      redirectToCollectionPage();
    });
  }
}

const pickMixSessionId =
  localStorage.getItem("pickMixSessionId") || new Date().getTime();
localStorage.setItem("pickMixSessionId", pickMixSessionId);

function redirectToCollectionPage() {
  const selectedCollection = localStorage.getItem("selectedCollection");

  if (selectedCollection) {
    const redirectUrl = `/collections/${selectedCollection}`;
    console.log("Redirecting to", redirectUrl);
    window.location.href = redirectUrl;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const storedPrice = localStorage.getItem("selectedPrice");
  if (storedPrice) {
    displayPrice(storedPrice);
  } else {
    console.log("No price found in localStorage.");
  }
});

function displayPrice(price) {
  const priceElement = document.querySelector("#priceDisplay");
  const priceElementMobile = document.querySelector("#priceDisplayMobile");
  if (priceElement) {
  } else {
    console.error("Price element not found on the page.");
  }
  if (priceElementMobile) {
  } else {
    console.error("Price element not found on the page.");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const bundlePrice = localStorage.getItem("selectedPrice");
  if (bundlePrice) {
    document.getElementById("priceDisplay").innerText = `${bundlePrice}`;  
    document.getElementById("priceDisplayMobile").innerText = `${bundlePrice}`;
  }

  const productLimit = localStorage.getItem("selectedSweetAmount");

  let maxSelections;
  if (productLimit.includes("x")) {
    const productParts = productLimit.split("x");
    maxSelections = parseInt(productParts[1].trim(), 10);
  } else {
    maxSelections = parseInt(productLimit, 10);
  }

  const selectedBagSize = localStorage.getItem("selectedBagSize");

  let totalBagWeight;
if (selectedBagSize === "1kg") {
  totalBagWeight = 1000;
} else if (selectedBagSize === "500g") {
  totalBagWeight = 500;
} else if (selectedBagSize === "250g") {
  totalBagWeight = 250;
} else if (selectedBagSize === "2kg") {
  totalBagWeight = 2000;
} else {
  totalBagWeight = 125;
}
const basePrice = localStorage.getItem("SelectedBasePrice");
console.log("Retrieved SelectedBasePrice:", basePrice);

let weightPerSweet;
if (localStorage.getItem("productButtonName") === "Bowl") {
  weightPerSweet = 250;
  console.log("Setting weightPerSweet to 250g as productButtonName is 'Bowl'");
  localStorage.setItem("CartDiscountCode", weightPerSweet);
} else {
  weightPerSweet = calculateIndividualSweetWeight(
    totalBagWeight,
    maxSelections
  );
}

console.log("Calculated weightPerSweet:", weightPerSweet);


 // Instead of hardcoding prices, fetch the correct variant price based on the weight
function setDynamicBasePrice(weightPerSweet) {
  // Determine the variant title based on weight
  let variantTitle;
  if (weightPerSweet === 1) {
    variantTitle = "1kg";
  } else if (weightPerSweet === 500) {
    variantTitle = "500g";
  } else if (weightPerSweet === 250) {
    variantTitle = "250g";
  } else if (weightPerSweet === 125) {
    variantTitle = "125g";
  }else if (weightPerSweet === 62.5) {
    variantTitle = "62.5g";
  } else {
    console.error("Unknown weightPerSweet:", weightPerSweet);
    return;
  }

  // Select the product container for the specific product ID
  const templateProductContainer = document.querySelector(".TemplateProduct .product--root");

  if (!templateProductContainer) {
    console.error("TemplateProduct container not found.");
    return;
  }

  // Find the price element for the variant with the matching title
  const variantPriceElement = templateProductContainer.querySelector(
    `.product--price[data-variant-title="${variantTitle}"]`
  );

  if (!variantPriceElement) {
    console.error(`No price element found for variant title: ${variantTitle}`);
    return;
  }

  // Extract the price text, handle comma decimals, and remove currency symbols
  let priceText = variantPriceElement.textContent.trim();
  console.log(`Raw price text extracted: "${priceText}"`);

  // Replace comma with a dot if present (for European currencies)
  priceText = priceText.replace(",", ".").replace(/[^\d.-]/g, "");
  console.log(`Standardized price text: "${priceText}"`);

  // Parse the standardized price
  const variantPrice = Math.ceil(parseFloat(priceText) * 100) / 100;

  if (isNaN(variantPrice)) {
    console.error("Invalid price retrieved for the matched variant.");
    return;
  }

  // Store the dynamically fetched price in localStorage
  localStorage.setItem("SelectedBasePrice", variantPrice);
  localStorage.setItem("SelectedVariantTitle", variantTitle);
  console.log(`Set SelectedBasePrice to: ${variantPrice} for variant title: ${variantTitle}`);
}


// Call the function to set the base price dynamically
setDynamicBasePrice(weightPerSweet);

  const button = document.getElementById("popup_btn_cart");
  button.href = `/cart`;

  document.querySelectorAll(".product--root").forEach((productCard) => {
    const productId = productCard.getAttribute("data-product-id");

    if (!productId) {
      console.warn("Product ID not found for this product card.");
      return;
    }

    const addToCartButton = productCard.querySelector(".add-to-cart-btn");
    const cornerPrice = productCard.querySelector(".corner-price");
    const cornerPriceOther = productCard.querySelector(".corner-price-other");
    if (!addToCartButton) {
      return;
    }
    console.log()
    const variantByWeight = findVariantByWeight(productId, weightPerSweet);
    if (variantByWeight) {
      addToCartButton.setAttribute(
        "data-variant-id",
        variantByWeight.variantId
      );
      

      if(cornerPrice) {
        cornerPrice.innerHTML = '+ ' + variantByWeight.price;
      }

      if(cornerPriceOther) {
        cornerPriceOther.innerHTML = '+ ' + variantByWeight.price;
      }
      

      let ProductButtonVariable = localStorage.getItem("productButtonName");
      if (ProductButtonVariable === "Large-Bowl" || ProductButtonVariable === "Regular-Bowl") {
          ProductButtonVariable = "bowl";
      }
        productCard.setAttribute("data-variant-id", variantByWeight.variantId);
      if (variantByWeight.inventory > 0) {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("out-of-stock");
        addToCartButton.innerText = `Add to ${ProductButtonVariable}`;
      } else {
        addToCartButton.setAttribute("disabled", "disabled");
        addToCartButton.classList.add("out-of-stock");
        addToCartButton.innerText = "Out of Stock";
      }
    } else {
      console.warn(
        `No matching variant found for product ${productId} with weight ${weightPerSweet}`
      );
      productCard.classList.add("Non-available-size");
    }
  });
});

const productLimit = localStorage.getItem("selectedSweetAmount");

let productName = "";
let Qty = 0;

if (productLimit.includes("x")) {
  const productParts = productLimit.split("x");
  productName = productParts[0].trim();
  Qty = productParts[1].trim();
} else {
  Qty = productLimit.trim();
}

let totalItemsAdded = 0;
const QtyLimit = parseInt(Qty, 10);

function removeProductFromLocalStorage(variantId) {
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const productToRemove = selectedProducts.find(
    (product) => product.variantId === variantId
  );

  if (productToRemove) {
    totalItemsAdded -= productToRemove.quantity;
    if (totalItemsAdded < 0) totalItemsAdded = 0;
    selectedProducts = selectedProducts.filter(
      (product) => product.variantId !== variantId
    );
    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
    const productCard = document.querySelector(
      `.product--root[data-variant-id="${variantId}"]`
    );
    if (productCard) {
      const addToCartBtn = productCard.querySelector(".add-to-cart-btn");
      const quantityControls = productCard.querySelector(".quantity-controls");
      const quantityInput = productCard.querySelector(".quantity-input");
      if (addToCartBtn) {
        console.log("Showing Add to Cart button");
        addToCartBtn.style.display = "block";
      } else {
        console.warn("Add to Cart button not found");
      }
      if (quantityControls) {
        console.log("Hiding quantity controls");
        quantityControls.style.display = "none";
      } else {
        console.warn("Quantity controls not found");
      }
      if (quantityInput) {
        quantityInput.value = 1;
      } else {
        console.warn("Quantity input not found");
      }
    } else {
      console.warn(`Product card for variantId ${variantId} not found`);
    }
    removeProductFromCartContainer(variantId);
    checkAndDisableButtons(QtyLimit);
    updateChoiceStatus(QtyLimit);
    updateTotalPriceDisplay();
    console.log(
      `Removed product (variantId: ${variantId}) and updated totalItemsAdded to ${totalItemsAdded}.`
    );
  } else {
    console.warn(
      `Product with variantId ${variantId} not found in localStorage.`
    );
  }
}


document.addEventListener("DOMContentLoaded", () => {

  const newLink = localStorage.getItem("productImage");

  if (newLink) {
    const imageElements = document.querySelectorAll("#imageSwapper");

    imageElements.forEach((imageElement) => {
      const baseUrl = "https://cdn.shopify.com/s/files/1/0520/3152/0924/files/";
      let sanitizedLink = newLink.replace(/^files\/+/, "").replace(/^\/+/, "");
      imageElement.src = `${baseUrl}${sanitizedLink}`;
      const className = sanitizedLink.replace(/\.[^/.]+$/, "");
      imageElement.classList.add(className);
    });
  }

  const productLimit = localStorage.getItem("selectedSweetAmount");

  let productName = "";
  let Qty = 0;

  if (productLimit.includes("x")) {
    const productParts = productLimit.split("x");
    productName = productParts[0].trim();
    Qty = productParts[1].trim();
  } else {
    Qty = productLimit.trim();
  }

  let totalItemsAdded = 0;
  const QtyLimit = parseInt(Qty, 10);
  const maxSelections = parseInt(Qty, 10);
  console.log(maxSelections);
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  totalItemsAdded = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );

  console.log(`Loaded ${totalItemsAdded} items from localStorage.`);
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      const cartItems = cartData.items;
      document.querySelectorAll(".product--root").forEach((productCard) => {
        const addToCartBtn = productCard.querySelector(
          ".add-to-cart-btn, .add-to-cart-btn__disabled"
        );

        if (!addToCartBtn) {
          console.warn("No add-to-cart button found for product:", productCard);
          return;
        }

        if (
          addToCartBtn.classList.contains("add-to-cart-btn__disabled") ||
          addToCartBtn.getAttribute("button-variant") === "disabled"
        ) {
          return;
        }

        const variantId = addToCartBtn.getAttribute("data-variant-id");
        const quantityInput = productCard.querySelector(".quantity-input");
        addToCartBtn.addEventListener("click", () => {
          console.log('testing');
          const quantity = parseInt(
            quantityInput ? quantityInput.value : 1,
            10
          );
          const title = productCard
            .querySelector(".product--title")
            .textContent.trim();
          const image = productCard
            .querySelector(".image--root img")
            .getAttribute("src");
          let priceElement = productCard.querySelector(".product--price span");

          // If the original price element is not found, look for the `.money` class
          if (!priceElement) {
            priceElement = productCard.querySelector(".product--price .money");
          }
          
          // Extract the price value if the element exists
          const price = priceElement
            ? parseFloat(
                priceElement.textContent.trim().replace(/[^\d.,]/g, "") // Removes currency symbols and spaces
              )
            : 0;


          addSelectedProductToLocalStorage(
            variantId,
            quantity,
            title,
            image,
            parseFloat(parseFloat(price).toFixed(2))
          );
          addToCartBtn.style.display = "none";
          const quantityControls =
            productCard.querySelector(".quantity-controls");
          if (quantityControls) quantityControls.style.display = "flex";
          updateTotalItemsAndCheckButtons(0);
        });
        setupQuantityButtons(productCard, variantId);
      });
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
    
  function addSelectedProductToLocalStorage(
    variantId,
    quantity,
    title,
    image,
    price
  ) {
    let productData = null;
    let variant = null;
    let productId = null;

    // Loop through productsData to find the correct product and variant
    for (const id in window.productsData) {
      const product = window.productsData[id];
      variant = product.variants.find((v) => v.variantId === variantId);
      if (variant) {
        productData = product;
        productId = id;
        break;
      }
    }
    if (!productData || !variant) {
      console.error(`No product or variant found for variantId: ${variantId}`);
      return;
    }
    price = parseFloat(variant.price.replace(",", ".").replace(/[^\d.-]/g, ""));
    console.log("HERE IS THE PRICE", price);
    const formattedPrice = parseFloat(price).toFixed(2);
    let selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const existingProduct = selectedProducts.find(
      (product) => product.variantId === variantId
    );
    if (existingProduct) {
      existingProduct.quantity += quantity;
      console.log(
        `Updated product (variantId: ${variantId}) quantity to ${existingProduct.quantity}.`
      );
    } else {
      selectedProducts.push({
        variantId,
        productId,
        quantity,
        title,
        image,
        price: formattedPrice,
      });
      console.log(
        `Added new product (variantId: ${variantId}) to selectedProducts.`
      );
    }
    const totalItemsAdded = selectedProducts.reduce(
      (total, product) => total + product.quantity,
      0
    );
    console.log(`Total items added: ${totalItemsAdded}/${maxSelections}.`);
    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
    updateCartContainer(
      variantId,
      title,
      image,
      formattedPrice,
      existingProduct ? existingProduct.quantity : quantity,
      productId
    );
    updateChoiceStatus(maxSelections);
    checkAndDisableButtons(maxSelections);
    updateTotalPriceDisplay();
  }


  function setupQuantityButtons(productCard, variantId) {
    const decreaseBtn = productCard.querySelector(".decrease-quantity");
    const increaseBtn = productCard.querySelector(".increase-quantity");
    const quantityInput = productCard.querySelector(".quantity-input");

    let productData = null;
    let variant = null;

    for (const productId in window.productsData) {
      const product = window.productsData[productId];
      variant = product.variants.find((v) => v.variantId === variantId);
      if (variant) {
        productData = product;
        break;
      }
    }

    if (!productData || !variant) {
      console.error(`No product or variant found for variantId: ${variantId}`);
      return;
    }

    let price = parseFloat(variant.price.replace(/[^\d.-]/g, ""));

    if (!decreaseBtn.hasAttribute("listener")) {
      decreaseBtn.addEventListener("click", () => {
        let quantity = parseInt(quantityInput.value, 10) || 1;

        if (quantity > 1) {
  quantity--;
  quantityInput.value = quantity;
  updateProductQuantityInLocalStorage(variantId, quantity);
  updateTotalItemsAndCheckButtons(-1);
  updateTotalPriceDisplay();

  const productId = productCard.getAttribute("data-product-id");
  
  // Updated price extraction to handle both original and currency-converted elements
  const priceElement =
    productCard.querySelector(".product--price span") ||
    productCard.querySelector(".product--price .money");
  const price = priceElement
    ? parseFloat(priceElement.textContent.trim().replace(/[^\d.,-]/g, ""))
    : 0;

  updateCartContainer(
    variantId,
    productCard.querySelector(".product--title").textContent.trim(),
    productCard.querySelector(".image--root img").getAttribute("src"),
    price,
    quantity,
    productId
  );
} else if (quantity === 1) {

          removeProductFromLocalStorage(variantId);
          quantityInput.value = 1;
          updateTotalItemsAndCheckButtons(-1);

          updateTotalPriceDisplay();

          removeProductFromCartContainer(variantId);
        }
      });

      decreaseBtn.setAttribute("listener", "true");
    }

    if (!increaseBtn.hasAttribute("listener")) {
      increaseBtn.addEventListener("click", () => {
        let quantity = parseInt(quantityInput.value, 10) || 1;
        quantity++;
        quantityInput.value = quantity;

        const title = productCard
          .querySelector(".product--title")
          .textContent.trim();
        const image = productCard
          .querySelector(".image--root img")
          .getAttribute("srcset");
        let priceElement = productCard.querySelector(".product--price span");

          // If the original price element is not found, look for the `.money` class
          if (!priceElement) {
            priceElement = productCard.querySelector(".product--price .money");
          }
          
          // Extract the price value if the element exists
          const price = priceElement
            ? parseFloat(
                priceElement.textContent.trim().replace(/[^\d.,]/g, "") // Removes currency symbols and spaces
              )
            : 0;

        const existingProduct = selectedProducts.find(
          (product) => product.variantId === variantId
        );
        

        if (!existingProduct) {
          addSelectedProductToLocalStorage(
            variantId,
            1,
            title,
            image,
            parseFloat(parseFloat(price).toFixed(2))
          );
          updateTotalItemsAndCheckButtons(1);
          updateTotalPriceDisplay();
        } else {

          updateProductQuantityInLocalStorage(variantId, quantity);
          updateTotalItemsAndCheckButtons(1);
          updateTotalPriceDisplay();
        }
        updateCartContainer(variantId, title, image, price, quantity);
      });
      increaseBtn.setAttribute("listener", "true");
    }
  }
  function checkAndDisableButtons(QtyLimit) {
    const selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const totalItemsAdded = selectedProducts.reduce(
      (total, product) => total + product.quantity,
      0
    );

    console.log(
      `Checking buttons. Total items added: ${totalItemsAdded}, Limit: ${QtyLimit}`
    );

    if (totalItemsAdded >= QtyLimit) {
      // Disable all quantity increase buttons
      document.querySelectorAll(".increase-quantity").forEach((button) => {
        button.disabled = true;
      });

      // Disable all add-to-cart buttons
      document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
        button.disabled = true;
      });

      // Optionally, show the 'Add All to Cart' button if limit reached
      showAddAllToCartButton();
    } else {
      // Re-enable buttons if limit is not reached
      document.querySelectorAll(".increase-quantity").forEach((button) => {
        button.disabled = false;
      });

      document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
        button.disabled = false;
      });

      hideAddAllToCartButton();
    }
    updateChoiceStatus(QtyLimit);
  }



  function updateTotalItemsAndCheckButtons(quantity) {
    totalItemsAdded += quantity;

    if (totalItemsAdded < 0) {
      totalItemsAdded = 0;
    }

    console.log(`Total items added: ${totalItemsAdded}`);
    checkAndDisableButtons(QtyLimit);
  }
  function updateProductQuantityInLocalStorage(variantId, quantity) {
    let selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const product = selectedProducts.find((p) => p.variantId === variantId);

    if (product) {
      product.quantity = quantity;
    }

    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
  }

  function hideAddAllToCartButton() {
    const addAllToCartBtnDesktop = document.querySelector(
      "#continueToCart button"
    );
    const addAllToCartBtnMobile = document.querySelector(
      "#continueToCartMobile button"
    );
    const priceDisplayDesktop = document.getElementById("priceDisplay");
    const priceDisplayMobile = document.getElementById("priceDisplayMobile");

    if (addAllToCartBtnDesktop) {
      addAllToCartBtnDesktop.style.display = "none";
      if (priceDisplayDesktop) {
        priceDisplayDesktop.style.display = "block";
      }
    }

    if (addAllToCartBtnMobile) {
      addAllToCartBtnMobile.style.display = "none";
      if (priceDisplayMobile) {
        priceDisplayMobile.style.display = "block";
      }
    }
  }
});

function updateChoiceStatus(maxSelections) {
  const totalItemsAdded = JSON.parse(
    localStorage.getItem("selectedProducts") || "[]"
  ).reduce((total, product) => total + product.quantity, 0);
  const remainingChoices = maxSelections - totalItemsAdded;

  console.log(`Updated Choices Status. Total Items Added: ${totalItemsAdded}`);
  console.log(`Updated Choices Status. Remaining Choices: ${remainingChoices}`);

  const choiceStatusDesktop = document.getElementById("choice-status");
  const choiceStatusMobile = document.getElementById("choice-status-mobile");
  const priceDisplayDesktop = document.getElementById("priceDisplay");
  const priceDisplayMobile = document.getElementById("priceDisplayMobile");
  const continueToCartWrapper = document.getElementById("continueToCart");
  const continueToCartButton = continueToCartWrapper
    ? continueToCartWrapper.querySelector("button")
    : null;
  const continueToCartWrapperMobile = document.getElementById(
    "continueToCartMobile"
  );
  const continueToCartButtonMobile = continueToCartWrapperMobile
    ? continueToCartWrapperMobile.querySelector("button")
    : null;

  if (remainingChoices > 0) {

    if (choiceStatusDesktop) {
      choiceStatusDesktop.innerHTML = `<span>${remainingChoices}</span> choices left!`;
      choiceStatusDesktop.style.display = "block";
    }
    if (choiceStatusMobile) {
      choiceStatusMobile.innerHTML = `<span>${remainingChoices}</span> choices left!`;
      choiceStatusMobile.style.display = "block";
    }
    if (priceDisplayDesktop) {
      priceDisplayDesktop.style.display = "block";
    }
    if (priceDisplayMobile) {
      priceDisplayMobile.style.display = "block";
    }
    if (continueToCartButton) {
      continueToCartButton.style.display = "none";
    }
    if (continueToCartButtonMobile) {
      continueToCartButtonMobile.style.display = "none";
    }
  } else {

    if (choiceStatusDesktop) choiceStatusDesktop.style.display = "none";
    if (choiceStatusMobile) choiceStatusMobile.style.display = "none";
    if (priceDisplayDesktop) priceDisplayDesktop.style.display = "none";
    if (priceDisplayMobile) priceDisplayMobile.style.display = "none";
    if (continueToCartButton) continueToCartButton.style.display = "flex";
    if (continueToCartButtonMobile)
      continueToCartButtonMobile.style.display = "flex";
  }

  console.log(`Updated UI. Remaining choices: ${remainingChoices}`);
}


function attachRemoveItemListeners() {
  document.querySelectorAll(".remove-item-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = button.getAttribute("data-variant-id");
      removeProductFromLocalStorage(variantId);
      removeProductFromCartContainer(variantId);
    });
  });
}

function removeProductFromCartContainer(variantId) {
  const cartContainerDesktop = document.getElementById("cart-items");
  const cartContainerMobile = document.getElementById("cart-items-mobile");

  [cartContainerDesktop, cartContainerMobile].forEach((cartContainer) => {
    if (!cartContainer) return;

    const cartItem = cartContainer.querySelector(
      `li[data-variant-id="${variantId}"]`
    );

    if (cartItem) {
      cartContainer.removeChild(cartItem);
      console.log(
        `Removed product (variantId: ${variantId}) from the cart container (${cartContainer.id}).`
      );
    }
  });
  updateTotalPriceDisplay();
}

function updateCartContainer(variantId, title, image, price, quantity, productId) {
  const cartContainerDesktop = document.getElementById("cart-items");
  const cartContainerMobile = document.getElementById("cart-items-mobile")
    // Standardize both basePrice and price by handling commas and converting from cents if necessary
const rawBasePrice = localStorage.getItem("SelectedBasePrice") || "0";
const standardizedBasePrice = parseFloat(rawBasePrice.replace(",", "."));

const rawPrice = price.toString().replace(",", ".");
const standardizedPrice = Number.isInteger(parseFloat(rawPrice)) && parseFloat(rawPrice) >= 100
  ? parseFloat(rawPrice) / 100
  : parseFloat(rawPrice);

// Round the standardized price
const roundedPrice = Math.ceil(standardizedPrice * 100) / 100;
const calculatedPrice = Math.ceil((roundedPrice - standardizedBasePrice) * 100) / 100;

console.log("Base Price:", standardizedBasePrice);
console.log("Price:", standardizedPrice);
console.log("Calculated Price:", calculatedPrice);
  const svgIcon = `<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7_1516)">
      <path d="M25.2304 10.2309C22.8417 4.96289 18.1086 1.375 12.6923 1.375C7.27604 1.375 2.54243 4.96719 0.152881 10.2309C0.0688822 10.4586 0 10.7852 0 11C0 11.2139 0.0688381 11.5414 0.152881 11.7318C2.54375 17.0371 7.27604 20.625 12.6923 20.625C18.1086 20.625 22.8417 17.0337 25.2304 11.7691C25.3141 11.5414 25.3846 11.1762 25.3846 11C25.3846 10.7852 25.3141 10.4586 25.2304 10.2309ZM12.6923 18.5625C8.30817 18.5625 4.26603 15.6621 2.13301 11.0387C4.27528 6.33359 8.3117 3.4375 12.6923 3.4375C17.0764 3.4375 21.1186 6.33789 23.2516 10.9613C21.0701 15.6664 17.0729 18.5625 12.6923 18.5625ZM12.6923 5.5C9.57652 5.5 7.05128 7.96211 7.05128 11C7.05128 14.0379 9.57784 16.5 12.6923 16.5C15.8054 16.5 18.3333 14.037 18.3333 11.0043C18.3333 7.96641 15.8081 5.5 12.6923 5.5ZM12.6923 14.4375C10.7484 14.4375 9.16667 12.8954 9.16667 11C9.16667 10.9679 9.17545 10.9381 9.17639 10.9062C9.40024 10.9613 9.62941 11 9.87179 11C11.4297 11 12.6923 9.76895 12.6923 8.25C12.6923 8.01453 12.6537 7.78937 12.5961 7.57195C12.6306 7.57109 12.6615 7.5625 12.6923 7.5625C14.6363 7.5625 16.2179 9.10465 16.2179 11.0021C16.2179 12.8949 14.6358 14.4375 12.6923 14.4375Z" fill="black"/>
      </g>
      <defs>
      <clipPath id="clip0_7_1516">
      <rect width="25.3846" height="22" fill="white"/>
      </clipPath>
      </defs>
      </svg>
      `;
  const createCartItemHTML = () => `
  <img src="${image}&width=150" alt="${title}" width="80">
  <div class="cartQuantityRemove">
    <p class="cart-item-quantity">${quantity}</p>
    <button class="remove-item-btn" data-variant-id="${variantId}">X</button>
  </div>
  <div class="product-quick__view quick-view-js">
    <button onclick="openpm('popup-${productId}')">${svgIcon}</button>
  </div>
  <div class="cart-item-details" style="opacity: ${
      roundedPrice > 0 ? "1" : "0"
  };">
    <p>+ ${price}</p>
  </div>
`;

  [cartContainerDesktop, cartContainerMobile].forEach((cartContainer) => {
    if (!cartContainer) return;

    let cartItem = cartContainer.querySelector(
      `li[data-variant-id="${variantId}"]`
    );

    if (!cartItem) {
      cartItem = document.createElement("li");
      cartItem.setAttribute("data-variant-id", variantId);
      cartItem.setAttribute("data-product-id", productId);
      cartItem.className = "cart-item";
      cartItem.innerHTML = createCartItemHTML(quantity);
      cartContainer.appendChild(cartItem);

      console.log(
        `Added product (variantId: ${variantId}) to the cart container (${cartContainer.id}).`
      );
    } else {
      const quantityElement = cartItem.querySelector(".cart-item-quantity");
      if (quantityElement) {
        quantityElement.textContent = `${quantity}`;
      }
      console.log(
        `Updated product (variantId: ${variantId}) quantity in the cart container (${cartContainer.id}).`
      );
    }
  });
  attachRemoveItemListeners();
}
function showAddAllToCartButton() {
  const addAllToCartBtnDesktop = document.querySelector(
    "#continueToCart button"
  );
  const addAllToCartBtnMobile = document.querySelector(
    "#continueToCartMobile button"
  );
  const priceDisplayDesktop = document.getElementById("priceDisplay");
  const priceDisplayMobile = document.getElementById("priceDisplayMobile");
  const ButtonProductName = localStorage.getItem("productButtonName");
  console.log(ButtonProductName);
  if (addAllToCartBtnDesktop) {
    addAllToCartBtnDesktop.style.display = "flex";
    console.log(
      "Selection limit reached. Showing 'Add All to Cart' button on desktop."
    );

    if (priceDisplayDesktop) {
      priceDisplayDesktop.style.display = "none";
      console.log("Hiding price display on desktop.");
    }

    let selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];

    if (!addAllToCartBtnDesktop.hasAttribute("listener")) {
      addAllToCartBtnDesktop.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        let selectedProducts =
            JSON.parse(localStorage.getItem("selectedProducts")) || [];

        console.log("Adding the following products:", selectedProducts);

        addMainProductAndBatch(selectedProducts, mainProductId);
      });

      addAllToCartBtnDesktop.setAttribute("listener", "true");
    }
  }

  if (addAllToCartBtnMobile) {
    addAllToCartBtnMobile.style.display = "flex";
    console.log(
      "Selection limit reached. Showing 'Add All to Cart' button on mobile."
    );

    if (priceDisplayMobile) {
      priceDisplayMobile.style.display = "none";
      console.log("Hiding price display on mobile.");
    }

    let selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];

    if (!addAllToCartBtnMobile.hasAttribute("listener")) {
      addAllToCartBtnMobile.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        let selectedProducts =
            JSON.parse(localStorage.getItem("selectedProducts")) || [];

        console.log("Adding the following products:", selectedProducts);

        addMainProductAndBatch(selectedProducts, mainProductId);
      });

      addAllToCartBtnDesktop.setAttribute("listener", "true");
    }
  }
}
function hideAddAllToCartButton() {
  const addAllToCartBtnDesktop = document.querySelector(
    "#continueToCart button"
  );
  const addAllToCartBtnMobile = document.querySelector(
    "#continueToCartMobile button"
  );

  if (addAllToCartBtnDesktop) {
    addAllToCartBtnDesktop.style.display = "none";
  }

  if (addAllToCartBtnMobile) {
    addAllToCartBtnMobile.style.display = "none";
  }
}
function checkAndDisableButtons(QtyLimit) {
  if (totalItemsAdded >= QtyLimit) {
    document.querySelectorAll(".increase-quantity").forEach((button) => {
      button.disabled = true;
    });
    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.disabled = true;
    });

    showAddAllToCartButton();
  } else {
    document.querySelectorAll(".increase-quantity").forEach((button) => {
      button.disabled = false;
    });

    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.disabled = false;
      hideAddAllToCartButton();
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  if (window.productsData) {
    for (const [productId, productData] of Object.entries(
      window.productsData
    )) {
      productData.variants.forEach((variant) => {
      });
    }
  } else {
    console.warn("No productsData found.");
  }

  const surpriseMeBtn = document.getElementById("surpriseMeBtn");
  const savedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  savedProducts.forEach((product) => {
    const productCard = document.querySelector(
      `.product--root[data-variant-id="${product.variantId}"]`
    );

    if (productCard) {
      const addToCartBtn = productCard.querySelector(".add-to-cart-btn");
      const quantityControls = productCard.querySelector(".quantity-controls");
      const quantityInput = productCard.querySelector(".quantity-input");

      if (addToCartBtn) addToCartBtn.style.display = "none";
      if (quantityControls) quantityControls.style.display = "flex";

      quantityInput.value = product.quantity;
      console.log(product.quantity);
    }
    updateCartContainer(
      product.variantId,
      product.title,
      product.image,
      product.price,
      product.quantity,
      product.productId
    );
  });

  totalItemsAdded = savedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  updateChoiceStatus(QtyLimit);
  checkAndDisableButtons(QtyLimit);

  if (totalItemsAdded >= QtyLimit) {
    showAddAllToCartButton();
  } else {
    hideAddAllToCartButton();
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const savedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];

  savedProducts.forEach((product) => {
    const productCard = document.querySelector(
      `.product--root[data-variant-id="${product.variantId}"]`
    );

    if (productCard) {
      const quantityInput = productCard.querySelector(".quantity-input");
      quantityInput.value = product.quantity;
      setupQuantityButtons(productCard, product.variantId);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const savedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  savedProducts.forEach((product) => {
    const productCard = document.querySelector(
      `.product--root[data-variant-id="${product.variantId}"]`
    );

    if (productCard) {
      const addToCartBtn = productCard.querySelector(".add-to-cart-btn");
      const quantityControls = productCard.querySelector(".quantity-controls");
      const quantityInput = productCard.querySelector(".quantity-input");
      if (addToCartBtn) {
        addToCartBtn.style.display = "none";
      }
      if (quantityControls) {
        quantityControls.style.display = "flex";
      }

      console.log(`Product card found for variantId: ${product.variantId}`);
      console.log(`Setting quantity to ${product.quantity}`);

      if (quantityInput) {
        quantityInput.value = product.quantity;
      }
      setupQuantityButtons(productCard, product.variantId);
    } else {
      console.log(`Product card NOT found for variantId: ${product.variantId}`);
    }
    updateCartContainer(
      product.variantId,
      product.title,
      product.image,
      product.price,
      product.quantity,
      product.id
    );
  });
  totalItemsAdded = savedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );

  updateChoiceStatus(QtyLimit);
  checkAndDisableButtons(QtyLimit);
  if (totalItemsAdded >= QtyLimit) {
    showAddAllToCartButton();
  } else {
    hideAddAllToCartButton();
  }
});

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function addMainProductAndBatch(products, mainProductId) {
  try {
    showCartOverlay();
    await addToCart(mainProductId);
    await delay(1000);
    await batchAddToCartWithRetry(products);
    hideCartOverlay();
  } catch (error) {
    console.error("Error in addMainProductAndBatch:", error);
  }
}

async function addToCart(productId) {
  if (!productId) return;

  const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const weightPerSweet = localStorage.getItem("CartDiscountCode");
  const childProductsSummary = selectedProducts
    .map((product) => `${product.title} - ${weightPerSweet}g (Qty: ${product.quantity})`)
    .join(", ");

  try {
    const response = await fetch("/cart/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1,
        properties: {
          _pickMixSessionId: localStorage.getItem("pickMixSessionId") || new Date().getTime(),
          _isMainProduct: true,
          _DietaryRequirement: localStorage.getItem("selectedCollection"),
          _childProducts: childProductsSummary,
        },
      }),
    });

    if (!response.ok) throw new Error("Failed to add main product to the cart.");
    const data = await response.json();
    console.log("Successfully added main product to the cart:", data);
  } catch (error) {
    console.error("Error adding main product to cart:", error);
  }
}

// async function getProductByHandle(id) {
//   const product = await fetch(`/products/${id}.js`).then(response => response.json());
//   return product;
// }
//
// function getVariantSurcharge(id, jsonData) {
//   return jsonData[id] || null;
// }

async function batchAddToCart(products) {

  // const jsonData = fetchDataSync();

  const addToCartBtnDesktop = document.querySelector("#continueToCart button span");
  const addToCartBtnMobile = document.querySelector("#continueToCartMobile button span");

  if (addToCartBtnDesktop) {
    addToCartBtnDesktop.textContent = "Adding...";
    addToCartBtnDesktop.disabled = true;
  }
  if (addToCartBtnMobile) {
    addToCartBtnMobile.textContent = "Adding...";
    addToCartBtnMobile.disabled = true;
  }

  // let pixMixTotalSurcharge = 0;

  const itemsToAdd = products.map((product) => {
    const basePrice = parseFloat(localStorage.getItem("SelectedBasePrice")) || 0;
    const productPrice = parseFloat(product.price);
    const surcharge = productPrice;
    const roundedSurcharge = Math.ceil(surcharge * 100) / 100;
    const pickMixBundlePricing = roundedSurcharge === 0 ? "FREE" : localStorage.getItem("CartDiscountCode");

    // pixMixTotalSurcharge += ( getVariantSurcharge(product.variantId, jsonData) * product.quantity);

    return {
      id: product.variantId,
      quantity: product.quantity,
      properties: {
        _pickMixSessionId: localStorage.getItem("pickMixSessionId") || new Date().getTime(),
        _isPMchoicetrue: "isPMchoicetrue",
        _PickNMixBundlePricing: pickMixBundlePricing,
      },
    };
  });

  // if( pixMixTotalSurcharge > 0 ) {
  //   const surchargeProduct = await getProductByHandle('p-m-surcharge');
  //   const basePrice = parseFloat(localStorage.getItem("SelectedBasePrice")) || 0;
  //   const gbpBasePrice = window.gbpBasePricing[localStorage.getItem("SelectedVariantTitle")];
  //   const conversionRate = basePrice / parseFloat(gbpBasePrice);
  //
  //   // console.log('Base Price: ' + basePrice);
  //   // console.log('GBP Base Price: ' + gbpBasePrice);
  //
  //   const surchargeInAltCurrency = Math.ceil(pixMixTotalSurcharge * conversionRate);
  //
  //   // console.log('Surcharge in GBP: ' + pixMixTotalSurcharge);
  //   // console.log('Surcharge in Alt Currency: ' + surchargeInAltCurrency);
  //
  //   const pixMixSurchargeQuantity = Math.ceil(pixMixTotalSurcharge / 0.25 );
  //   const pixMixSurchargeQuantityAltCurrency = Math.ceil(surchargeInAltCurrency / (surchargeProduct.price / 100) );
  //
  //   // console.log('Surcharge Product Price GBP: 0.25');
  //   // console.log('Surcharge Product Price Alt Currency: ' + (surchargeProduct.price / 100));
  //   // console.log('Quantity in GBP: ' + pixMixSurchargeQuantity);
  //   // console.log('Quantity in Alt Currency: ' + pixMixSurchargeQuantityAltCurrency);
  //
  //   const pixMixSurchargeProduct = {
  //     id: surchargeProduct.variants[0].id,
  //     quantity: pixMixSurchargeQuantityAltCurrency,
  //     properties: {
  //       _pickMixSessionId: localStorage.getItem("pickMixSessionId") || new Date().getTime(),
  //       _isPMchoicetrue: "isPMchoicetrue",
  //     }
  //   }
  //   itemsToAdd.push(pixMixSurchargeProduct);
  // }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    if (!response.ok) throw new Error("Failed to add products to the cart.");
    const cartData = await response.json();
    console.log("Successfully added products to the cart:", cartData);
    localStorage.clear();

    if (addToCartBtnDesktop) {
      addToCartBtnDesktop.textContent = "Go to Cart";
      addToCartBtnDesktop.disabled = false;
    }
    if (addToCartBtnMobile) {
      addToCartBtnMobile.textContent = "Go to Cart";
      addToCartBtnMobile.disabled = false;
    }

    showPopup();
  } catch (error) {
    console.error("Error adding products to the cart:", error);

    if (addToCartBtnDesktop) {
      addToCartBtnDesktop.textContent = "Add to Cart";
      addToCartBtnDesktop.disabled = false;
    }
    if (addToCartBtnMobile) {
      addToCartBtnMobile.textContent = "Add to Cart";
      addToCartBtnMobile.disabled = false;
    }
  }
}

async function batchAddToCartWithRetry(products, maxRetries = 3) {
  let attempts = 0;
  while (attempts < maxRetries) {
    try {
      await batchAddToCart(products);
      return;
    } catch (error) {
      attempts++;
      console.error(`Retrying batchAddToCart, Attempt: ${attempts}`);
      await delay(1000);
    }
  }
  console.error("Failed to add child products after multiple attempts.");
}


function showCartOverlay() {
  const overlay = document.getElementById("cartOverlay");
  overlay.classList.add("show");
  document.body.classList.add("no-interaction");
}

function hideCartOverlay() {
  const overlay = document.getElementById("cartOverlay");
  overlay.classList.remove("show");
  document.body.classList.remove("no-interaction");
}



function openpm(popupId) {
  const popupElement = document.getElementById(popupId);
  if (popupElement) {
    //document.querySelector(".off-canvas--overlay").style.display = "block";
    //document.querySelector(".off-canvas--overlay").style.opacity = "0.5";
    popupElement.style.display = "block";
    document.body.classList.add("body-overflow");
  }
}
function closepm(popupId) {
  const popupElement = document.getElementById(popupId);
  if (popupElement) {
    document.body.classList.remove("body-overflow");
    // document.querySelector(".off-canvas--overlay").style.display = "none";
    // document.querySelector(".off-canvas--overlay").style.opacity = "0";
    popupElement.style.display = "none";
    popupElement.querySelector(".text-success-text").style.display = "none";
    popupElement.querySelector(".contactFormSubmissions").style.display =
      "block";
  }
}
document.querySelectorAll(".pmSubmit").forEach((button) => {
  button.addEventListener("click", function () {
    const popupId = this.getAttribute("data-popup-id");
  });
});
window.onload = function () {
  const popupId = localStorage.getItem("popupOpen");

  if (popupId) {
    const popupElement = document.getElementById(popupId);
    if (popupElement) {
      // document.querySelector(".off-canvas--overlay").style.display = "block";
      // document.querySelector(".off-canvas--overlay").style.opacity = "0.5";
      popupElement.style.display = "block";
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  const selectedBagSize = localStorage.getItem("selectedBagSize");
  const productLimit = localStorage.getItem("selectedSweetAmount");
  if (!productLimit) {
    console.error("Product limit not found.");
    return;
  }

  let productName = "";
  let Qty = 0;
  if (productLimit.includes("x")) {
    const productParts = productLimit.split("x");
    productName = productParts[0].trim();
    Qty = productParts[1].trim();
  } else {
    Qty = productLimit.trim();
  }
  const maxSelections = parseInt(Qty, 10);
  let totalBagWeight = 0;

  switch (selectedBagSize) {
    case "1kg":
      totalBagWeight = 1000;
      break;
    case "500g":
      totalBagWeight = 500;
      break;
    case "250g":
      totalBagWeight = 250;
      break;
    default:
      totalBagWeight = 125;
  }
});
function calculateSurplusPrice(variantPrice, totalBagWeight) {
  const basePrice = getBasePrice(totalBagWeight);
  const surplusPrice = variantPrice - basePrice;
  return surplusPrice > 0 ? surplusPrice.toFixed(2) : "";
}
function calculateIndividualSweetWeight(totalBagWeight, maxSelections) {
  let weightPerSweet = totalBagWeight / maxSelections;
  localStorage.setItem("weightPerSweet", weightPerSweet);
  const ProductWeightName = localStorage.getItem("productButtonName");
  if (weightPerSweet < minWeight) {
    weightPerSweet = minWeight;
  }
  if (weightPerSweet === 1000) {
    weightPerSweet = 1;
  } else if (ProductWeightName === "Bowl") {
    weightPerSweet = 250;
  } else if (ProductWeightName === "Platter") {
    weightPerSweet = 250;
  }
  console.log(weightPerSweet);
  localStorage.setItem("CartDiscountCode", weightPerSweet);
  return weightPerSweet;
}

function findVariantByWeight(productId, weightPerSweet) {
  const product = window.productsData[productId];
  const productButtonName = localStorage.getItem("productButtonName");

  if (!product || !product.variants) {
    console.warn(`No variants found for product ${productId}.`);
    return null;
  }

  // Check for "Bowl" or "Platter" selection and use specific variants
  if (productButtonName === "Regular-Bowl" || productButtonName === "Large-Bowl") {
    console.log("Bowl selected, using 'B' variant.");
    const bowlVariant = product.variants.find((variant) => variant.title.includes("B"));
    if (bowlVariant) {
      return bowlVariant;
    } else {
      console.warn("No 'B' variant found for Bowl.");
      return null;
    }
  }

  if (productButtonName === "Platter") {
    console.log("Platter selected, using 'P' variant.");
    const platterVariant = product.variants.find((variant) => variant.title.includes("P"));
    if (platterVariant) {
      return platterVariant;
    } else {
      console.warn("No 'P' variant found for Platter.");
      return null;
    }
  }

  // Normalize weight for comparison if not Bowl or Platter
  let weightToMatch;
  if (weightPerSweet === 1 || weightPerSweet === 1000) {
    weightToMatch = "1kg";
  } else if (weightPerSweet === 2000) {
    weightToMatch = "2kg";
  } else {
    weightToMatch = `${weightPerSweet}g`;
  }

  console.log(`Looking for variant with weight: ${weightToMatch}`);

  const variantByWeight = product.variants.find((variant) => {
    if (!variant || !variant.title) {
      console.warn(`Variant is missing essential data for product ${productId}`);
      return false;
    }
    const weightRegex = /(\d+)(g|kg)/i;
    var match = variant.title.toLowerCase().match(weightRegex);
    if(variant.title.indexOf('62.5') > -1) {
      match = variant.title.split('g')[0] + 'g';
    }

    if (match) {
      var variantWeight = `${match[1]}${match[2].toLowerCase().replace(/\s+/g, '')}`;
      if(match.indexOf('62.5') > -1) {
        variantWeight = '62.5g';
      }
      console.log(`Checking variant: ${variant.title}, extracted weight: ${variantWeight}`);
      return variantWeight === weightToMatch.toLowerCase();
    }

    return false;
  });

  if (variantByWeight) {
    console.log(`Matching variant found for weight: ${weightToMatch}`, variantByWeight);
    localStorage.setItem('weightPerSweet', weightPerSweet);
    return variantByWeight;
  } else {
    console.log(`No matching variant found for weight: ${weightToMatch}`);
    return null;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const selectedCollection = localStorage.getItem("selectedCollection");

  if (selectedCollection) {
    const currentPathArray = window.location.pathname.split("/");
    const baseCollectionSlug = selectedCollection.toLowerCase();

    console.log("Selected Collection from localStorage:", baseCollectionSlug);
    console.log("Current Path Array:", currentPathArray);

    if (currentPathArray.length > 2) {
      const currentCollectionSlug = currentPathArray[2].toLowerCase();
      console.log("Current Collection Slug from URL:", currentCollectionSlug);
      if (currentCollectionSlug !== baseCollectionSlug) {
        console.log(
          `Navigated away from the ${selectedCollection} collection. Clearing localStorage.`
        );
        localStorage.clear();
      } else {
        console.log(
          `Still on the ${selectedCollection} collection. Keeping localStorage.`
        );
      }
    } else {
      console.log(
        `URL structure seems unexpected. Clearing localStorage as a precaution.`
      );
      localStorage.clear();
    }
  } else {
    console.log("No collection selected, nothing to check.");
  }
});

document.querySelector(".surprise-me-btn").addEventListener("click", () => {
  ensureSufficientProducts();
});

function ensureSufficientProducts() {
  const productLimitSurprise = localStorage.getItem("selectedSweetAmount");

  let MAX_CHOICES;
  if (productLimitSurprise && productLimitSurprise.includes("x")) {
    MAX_CHOICES = parseInt(productLimitSurprise.split("x")[1].trim(), 10);
  } else {
    MAX_CHOICES = parseInt(productLimitSurprise, 10);
  }

  const availableProducts = getAvailableProducts();
  console.log("Available Products:", availableProducts);

  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  let totalQuantity = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  let remainingChoices = MAX_CHOICES - totalQuantity;

  if (remainingChoices <= 0) {
    console.log("No more products needed.");
    return;
  }

  if (availableProducts.length === 0) {
    console.warn("No available products to choose from.");
    return;
  }

  // Shuffle the available products randomly
  availableProducts.sort(() => 0.5 - Math.random());
  const productsToAdd = [];

  function addProduct(product, quantity) {
    const weightPerSweet = parseInt(localStorage.getItem("weightPerSweet"), 10);

    // Find the correct variant by weight
    const variantByWeight = findVariantByWeight(
      product.productId,
      weightPerSweet
    );

    if (!variantByWeight) {
      console.warn(
        `No matching variant found for product ${product.productId} with weight ${weightPerSweet}`
      );
      return;
    }

    // Check if the variant is in stock
    if (variantByWeight.inventory <= 0) {
      console.warn(`Variant is out of stock: ${variantByWeight.title}`);
      return;
    }

    console.log("Correct variant found and in stock:", variantByWeight);

    const correctPrice = parseFloat(
      variantByWeight.price.replace(",", ".").replace(/[^\d.-]/g, "")
    );
    productsToAdd.push({
      variantId: variantByWeight.variantId,
      title: product.title,
      image: product.image,
      price: correctPrice.toFixed(2),
      quantity: quantity,
      productId: product.productId,
    });
  }

  // Loop through the available products and add them if there are remaining choices
  availableProducts.forEach((product) => {
    if (remainingChoices <= 0) return;

    const quantityToAdd = Math.min(product.quantity, remainingChoices);
    addProduct(product, quantityToAdd);
    remainingChoices -= quantityToAdd;
  });

  // If there are still remaining choices, continue adding products until the limit is reached
  if (remainingChoices > 0) {
    let i = 0;
    while (remainingChoices > 0) {
      const product = availableProducts[i % availableProducts.length];
      const quantityToAdd = Math.min(product.quantity, remainingChoices);

      addProduct(product, quantityToAdd);
      remainingChoices -= quantityToAdd;
      i++;
    }
  }

  console.log("Products to add to meet the remaining choices:", productsToAdd);
  addProductsToLocalStorage(productsToAdd);
  updateChoiceStatus(MAX_CHOICES);
}




function addProductsToLocalStorage(products) {
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];

  products.forEach((product) => {
    const existingProduct = selectedProducts.find(
      (p) => p.variantId === product.variantId
    );

    if (existingProduct) {
      existingProduct.quantity += product.quantity;
    } else {
      selectedProducts.push({
        variantId: product.variantId,
        title: product.title,
        image: product.image,
        price: product.price,
        quantity: product.quantity,
        productId: product.productId,
        inventory: product.inventory
      });
    }
  });

  localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
  updateUIAfterSurpriseMe();
}


function getAvailableProducts() {
  const products = [];

  document.querySelectorAll(".product--root").forEach((productCard) => {
    const variantId = productCard.getAttribute("data-variant-id");
    const productId = productCard.getAttribute("data-product-id");
    const title = productCard
      .querySelector(".product--title")
      ?.textContent.trim();
    const image = productCard
      .querySelector(".image--root img")
      ?.getAttribute("srcset").append("&width=150");
    const quantity = parseInt(
      productCard.querySelector(".quantity-input")?.value || "0",
      10
    );
    const isInStock = !productCard.querySelector(".add-to-cart-btn__disabled");
    if (variantId && title && image && quantity > 0 && isInStock) {
      products.push({
        variantId: variantId,
        title: title,
        image: image,
        price: parseFloat(
          productCard
            .querySelector(".product--price span")
            ?.textContent.trim()
            .replace("£", "") || "0"
        ),
        quantity: quantity,
        productId: productId,
      });
    }
  });
  return products;
}
function updateUIAfterSurpriseMe() {
  console.log("updateUIAfterSurpriseMe called");
  const productLimitSurprise = localStorage.getItem("selectedSweetAmount");
  let MAX_CHOICES;
  if (productLimitSurprise && productLimitSurprise.includes("x")) {
    MAX_CHOICES = parseInt(productLimitSurprise.split("x")[1].trim(), 10);
  } else {
    MAX_CHOICES = parseInt(productLimitSurprise, 10);
  }

  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const totalItemsAdded = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  const remainingChoices = MAX_CHOICES - totalItemsAdded;
  const choiceStatusDesktop = document.getElementById("choice-status");
  const choiceStatusMobile = document.getElementById("choice-status-mobile");
  const priceDisplayDesktop = document.getElementById("priceDisplay");
  const priceDisplayMobile = document.getElementById("priceDisplayMobile");
  const continueToCartButton = document.getElementById("continueToCart");
  const continueToCartButtonMobile = document.getElementById(
    "continueToCartMobile"
  );
  if (remainingChoices > 0) {
    if (choiceStatusDesktop)
      choiceStatusDesktop.innerHTML = `<span>${remainingChoices}</span> choices left!`;
    if (choiceStatusMobile)
      choiceStatusMobile.innerHTML = `<span>${remainingChoices}</span> choices left!`;
    if (priceDisplayDesktop) priceDisplayDesktop.style.display = "none";
    if (priceDisplayMobile) priceDisplayMobile.style.display = "none";
    if (continueToCartButton) continueToCartButton.style.display = "none";
    if (continueToCartButtonMobile)
      continueToCartButtonMobile.style.display = "none";
  } else {
    if (choiceStatusDesktop) choiceStatusDesktop.style.display = "none";
    if (choiceStatusMobile) choiceStatusMobile.style.display = "none";
    if (priceDisplayDesktop) priceDisplayDesktop.style.display = "block";
    if (priceDisplayMobile) priceDisplayMobile.style.display = "block";
    if (continueToCartButton) continueToCartButton.style.display = "block";
    if (continueToCartButtonMobile)
      continueToCartButtonMobile.style.display = "block";
  }
  selectedProducts.forEach((product) => {
    const productCard = document.querySelector(
      `.product--root[data-variant-id="${product.variantId}"]`
    );
    if (productCard) {
      const quantityInput = productCard.querySelector(".quantity-input");
      const addToCartBtn = productCard.querySelector(".add-to-cart-btn");
      const quantityControls = productCard.querySelector(".quantity-controls");
      if (quantityInput) {
        quantityInput.value = product.quantity;
        quantityInput.disabled = true;
      }
      if (addToCartBtn) {
        addToCartBtn.style.display = "none";
        addToCartBtn.disabled = true;
      }
      if (quantityControls) {
        quantityControls.style.display = "flex";
      }
    }
  });
  if (totalItemsAdded >= MAX_CHOICES) {
    document.querySelectorAll(".increase-quantity").forEach((button) => {
      button.disabled = true;
    });
    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.disabled = true;
    });
    showAddAllToCartButton();
  } else {
    document.querySelectorAll(".increase-quantity").forEach((button) => {
      button.disabled = false;
    });
    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.disabled = false;
    });
    hideAddAllToCartButton();
  }

  console.log("Updated UI after Surprise Me: buttons disabled where needed.");
  updateCartContainerAfterSurpriseMe();
  setupAddToCartButton();
}


function updateCartContainerAfterSurpriseMe() {
  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const cartContainerDesktop = document.getElementById("cart-items");
  const cartContainerMobile = document.getElementById("cart-items-mobile");

  cartContainerDesktop.innerHTML = "";
  cartContainerMobile.innerHTML = "";

  selectedProducts.forEach((product) => {
    const { image, title, quantity, variantId, price, productId } = product;

      // Standardize both basePrice and price by handling commas and converting from cents if necessary
const rawBasePrice = localStorage.getItem("SelectedBasePrice") || "0";
const standardizedBasePrice = parseFloat(rawBasePrice.replace(",", "."));

const rawPrice = price.toString().replace(",", ".");
const standardizedPrice = Number.isInteger(parseFloat(rawPrice)) && parseFloat(rawPrice) >= 100
  ? parseFloat(rawPrice) / 100
  : parseFloat(rawPrice);

// Round the standardized price
const roundedPrice = Math.ceil(standardizedPrice * 100) / 100;
const calculatedPrice = Math.ceil((roundedPrice - standardizedBasePrice) * 100) / 100;
    const svgIcon = `<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7_1516)">
      <path d="M25.2304 10.2309C22.8417 4.96289 18.1086 1.375 12.6923 1.375C7.27604 1.375 2.54243 4.96719 0.152881 10.2309C0.0688822 10.4586 0 10.7852 0 11C0 11.2139 0.0688381 11.5414 0.152881 11.7318C2.54375 17.0371 7.27604 20.625 12.6923 20.625C18.1086 20.625 22.8417 17.0337 25.2304 11.7691C25.3141 11.5414 25.3846 11.1762 25.3846 11C25.3846 10.7852 25.3141 10.4586 25.2304 10.2309ZM12.6923 18.5625C8.30817 18.5625 4.26603 15.6621 2.13301 11.0387C4.27528 6.33359 8.3117 3.4375 12.6923 3.4375C17.0764 3.4375 21.1186 6.33789 23.2516 10.9613C21.0701 15.6664 17.0729 18.5625 12.6923 18.5625ZM12.6923 5.5C9.57652 5.5 7.05128 7.96211 7.05128 11C7.05128 14.0379 9.57784 16.5 12.6923 16.5C15.8054 16.5 18.3333 14.037 18.3333 11.0043C18.3333 7.96641 15.8081 5.5 12.6923 5.5ZM12.6923 14.4375C10.7484 14.4375 9.16667 12.8954 9.16667 11C9.16667 10.9679 9.17545 10.9381 9.17639 10.9062C9.40024 10.9613 9.62941 11 9.87179 11C11.4297 11 12.6923 9.76895 12.6923 8.25C12.6923 8.01453 12.6537 7.78937 12.5961 7.57195C12.6306 7.57109 12.6615 7.5625 12.6923 7.5625C14.6363 7.5625 16.2179 9.10465 16.2179 11.0021C16.2179 12.8949 14.6358 14.4375 12.6923 14.4375Z" fill="black"/>
      </g>
      <defs>
      <clipPath id="clip0_7_1516">
      <rect width="25.3846" height="22" fill="white"/>
      </clipPath>
      </defs>
      </svg>
      `;

    const cartItemHTML = `
    <li class="cart-item" data-variant-id="${variantId}" data-product-id="${productId}">
  <img src="${image}?width=150" alt="${title}" width="80">
  <div class="cartQuantityRemove">
    <p class="cart-item-quantity">${quantity}</p>
    <button class="remove-item-btn" data-variant-id="${variantId}">X</button>
  </div>
  <div class="product-quick__view quick-view-js">
    <button onclick="openpm('popup-${productId}')">${svgIcon}</button>
  </div>
  <div class="cart-item-details" style="opacity: ${
    calculatedPrice > 0 ? "1" : "0"
  };">
    <p>+ ${price}</p>
  </div>
  </li>
`;
    cartContainerDesktop.innerHTML += cartItemHTML;
    cartContainerMobile.innerHTML += cartItemHTML;
  });

  attachRemoveItemListeners();
  console.log("Cart container updated.");
}


function setupAddToCartButton() {
  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const addAllToCartBtn = document.querySelector("#continueToCart button");
  const addAllToCartBtnMobile = document.querySelector("#continueToCartMobile");
  if (addAllToCartBtn && !addAllToCartBtn.hasAttribute("listener")) {
    addAllToCartBtn.addEventListener("click", () => {
      addMainProductAndBatch(selectedProducts, mainProductId);
    });
    addAllToCartBtn.setAttribute("listener", "true");
  }
  if (
    addAllToCartBtnMobile &&
    !addAllToCartBtnMobile.hasAttribute("listener")
  ) {
    addAllToCartBtnMobile.addEventListener("click", () => {
      addMainProductAndBatch(selectedProducts, mainProductId);
    });
    addAllToCartBtnMobile.setAttribute("listener", "true");
  }
}
function showPopup() {
  const popup = document.getElementById("cart-popup");
  const popupButtons = document.querySelectorAll(".popup_btn");
  if (popup) {
    popup.style.display = "block";
    // document.querySelector(".off-canvas--overlay").style.display = "block";
    // document.querySelector(".off-canvas--overlay").style.opacity = "0.5";
    document.body.classList.add("body-overflow");

    popupButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        localStorage.removeItem("selectedProducts");
        localStorage.removeItem("selectedCollection");
        localStorage.removeItem("selectedPrice");
        localStorage.removeItem("selectedSweetAmount");
        localStorage.removeItem("pickMixSessionId");
      });
    });
    
  } else {
    console.warn("Popup container not found.");
  }
}

function getProductByHandleSync(id) {
  const cacheKey = `product_${id}`;
  const cachedProduct = sessionStorage.getItem(cacheKey);

  if (cachedProduct) {
    // If the product is already cached, return the cached data
    return JSON.parse(cachedProduct);
  }

  const xhr = new XMLHttpRequest();
  xhr.open('GET', `/products/${id}.js`, false); // `false` makes the request synchronous
  xhr.send();

  if (xhr.status === 200) {
    try {
      const product = JSON.parse(xhr.responseText);
      // Cache the product data in sessionStorage
      sessionStorage.setItem(cacheKey, JSON.stringify(product));
      return product;
    } catch (error) {
      throw new Error('Failed to parse JSON response');
    }
  } else {
    throw new Error(`Request failed with status ${xhr.status}`);
  }
}

function updateTotalPriceDisplay() {

  // const jsonData = fetchDataSync();

  // const surchargeProduct = getProductByHandleSync('p-m-surcharge');

  const basePrice = parseFloat(localStorage.getItem("SelectedBasePrice")) || 0;
  console.log("Base Price:", basePrice);

  const initialSelectedPrice =
    parseFloat(localStorage.getItem("selectedPrice")) || 0;
  console.log("Initial Selected Price:", initialSelectedPrice);

  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  console.log("Selected Products:", selectedProducts);

  // let pixMixTotalSurcharge = 0;
  // let totalSurcharge = 0;
  //
  // selectedProducts.map((product) => {
  //   pixMixTotalSurcharge += (getVariantSurcharge(product.variantId, jsonData) * product.quantity);
  // });
  //
  // if( pixMixTotalSurcharge > 0 ) {
  //
  //   const basePrice = parseFloat(localStorage.getItem("SelectedBasePrice")) || 0;
  //   const gbpBasePrice = window.gbpBasePricing[localStorage.getItem("SelectedVariantTitle")];
  //   const conversionRate = basePrice / parseFloat(gbpBasePrice);
  //
  //   const surchargeInAltCurrency = Math.ceil(pixMixTotalSurcharge * conversionRate);
  //
  //   totalSurcharge = surchargeInAltCurrency;
  // }

  const totalSurcharge = selectedProducts.reduce((total, product) => {
    const productPrice = parseFloat(product.price);
    const calculatedSurcharge = productPrice;
    const surchargeToAdd = ( calculatedSurcharge * product.quantity );

    console.log('BENN');
    console.log(surchargeToAdd);

    // Round up the surcharge per unit
    // const roundedSurchargePerUnit =
    //   calculatedSurcharge > 0 ? Math.ceil(calculatedSurcharge * 100) / 100 : 0;
    //
    // // Calculate the total surcharge for this product and round it up
    // const surchargeToAdd = Math.ceil(
    //   roundedSurchargePerUnit * product.quantity * 100
    // ) / 100;

    console.log(
      `Product: ${product.title}, Quantity: ${product.quantity}, Rounded Surcharge per Unit: , Added Surcharge: ${surchargeToAdd}`
    );

    return total + surchargeToAdd;
  }, 0);

  console.log("Total Surcharge (rounded up):", totalSurcharge);

  // Calculate the final total price and round it up
  const finalTotalPrice = initialSelectedPrice + totalSurcharge;
  const roundedUpTotalPrice = Math.ceil(finalTotalPrice * 100) / 100;

  console.log(
    "Final Total Price (selectedPrice + Total Surcharge) rounded up:",
    roundedUpTotalPrice
  );

  const formattedTotalPrice = `${roundedUpTotalPrice.toFixed(2)}`;
  document.getElementById("priceDisplay").textContent = formattedTotalPrice;
  document.getElementById("priceDisplayMobile").textContent =
    formattedTotalPrice;
  localStorage.setItem("formattedTotalPrice", formattedTotalPrice);
}



document.addEventListener("DOMContentLoaded", () => {
  const localStorageKey = "selectedPrice";
  const redirectPrevUrl = "https://poppin-candy.com/pages/pick-n-mix";

  if (localStorage.getItem(localStorageKey) === null) {
    window.location.href = redirectPrevUrl;
    console.log(redirectPrevUrl);
  } else {
    console.log("HERES AN ERROR");
  }
  let savedFormattedTotalPrice =
    localStorage.getItem("formattedTotalPrice") || "£0.00";
  if (savedFormattedTotalPrice === "£0.00") {
    const selectedPrice =
      parseFloat(localStorage.getItem("selectedPrice")) || 0;
    savedFormattedTotalPrice = `${selectedPrice.toFixed(2)}`;
  }

  document.getElementById("priceDisplay").textContent =
    savedFormattedTotalPrice;
  document.getElementById("priceDisplayMobile").textContent =
    savedFormattedTotalPrice;
});



// Function to log all variants and their prices
function logAllVariantsAndPrices() {
  if (!window.productsData) {
    console.warn("No productsData found on the page.");
    return;
  }

  console.log("Logging all product variants and their prices:");

  // Iterate through each product in productsData
  for (const [productId, productData] of Object.entries(window.productsData)) {
    console.log(`Product ID: ${productId}, Product Title: ${productData.title}`);

    if (!productData.variants || productData.variants.length === 0) {
      console.warn(`No variants found for Product ID: ${productId}`);
      continue;
    }

    // Iterate through each variant of the product
    productData.variants.forEach((variant) => {
      const variantId = variant.variantId || "No Variant ID";
      const variantTitle = variant.title || "No Variant Title";
      const rawPrice = variant.price || "No Price";

      // Parse and standardize the price
      const standardizedPrice = parseFloat(rawPrice.replace(/[^\d.-]/g, ""));
      const formattedPrice = standardizedPrice ? standardizedPrice.toFixed(2) : "Invalid Price";

      console.log(`  - Variant ID: ${variantId}`);
      console.log(`  - Variant Title: ${variantTitle}`);
      console.log(`  - Raw Price: ${rawPrice}`);
      console.log(`  - Standardized Price: ${formattedPrice}`);
    });
  }
}

// Call the function to log the variants and their prices
logAllVariantsAndPrices();
